import React from 'react'
import classnames from 'classnames'
import {useTranslation} from 'react-i18next'
import {Tooltip} from 'antd'
import {Button, Icon, Input} from '@/components'
import styles from './styles.scss'
import {COPY_PAYMENT_LINK, PAYMENT_LINK_VALUE_IN_FIELD} from '@/constants/playwright-ids'

type Props = {
    url: string
    buttonLabel?: string
    disabled?: boolean
}

export const CopyLink: React.FC<Props> = ({url, buttonLabel, disabled = false}) => {
    const {t} = useTranslation()
    return (
        <div className={styles.copyLink}>
            <Input
                className={styles.input}
                value={url}
                placeholder={'link'}
                data-test-id={PAYMENT_LINK_VALUE_IN_FIELD}
                disabled={disabled}
            />
            <Tooltip title={t('CopyLink.copied')} placement={'top'} trigger={'click'}>
                <Button
                    className={classnames(styles.btn, {
                        [styles.btnWithLabel]: !!buttonLabel
                    })}
                    type={'primary'}
                    {...(!buttonLabel && {
                        icon: <Icon className={styles.copy} type='copy' />
                    })}
                    onClick={() => {
                        navigator.clipboard.writeText(url)
                    }}
                    data-test-id={COPY_PAYMENT_LINK}
                >
                    {buttonLabel}
                </Button>
            </Tooltip>
        </div>
    )
}
